import React from 'react';
import BodyText, { BodyTextProps } from '../../Text/BodyText/BodyText';
import { withStyles } from '../../../utils/utils';
import styles from './DetailRows.module.scss';

const cn = withStyles(styles);

export interface DetailRow {
  label: React.ReactNode;
  value: React.ReactNode;
  visible?: boolean;
  /** Stamped on the row; the label and value get `-label` / `-value` suffixes for tests that read them. */
  'data-testid'?: string;
}

export interface DetailRowsProps {
  details: DetailRow[];
  className?: string;
  rowSeparators?: boolean;
  /** The text size of every label and value; `sm` is the 13px Body style the account pages use. */
  size?: BodyTextProps['size'];
}

export default function DetailRows({ details, className, rowSeparators = true, size = 'rg' }: DetailRowsProps) {
  const visibleDetails = details.filter(({ visible = true }) => visible);

  if (visibleDetails.length === 0) {
    return null;
  }

  return (
    <div className={cn('detailsContainer', className)} data-testid="detail-rows">
      {visibleDetails.map((detail, index) => {
        const testId = detail['data-testid'];

        return (
          <div key={index} className={cn('detailRow', !rowSeparators && 'noRowSeparator')} data-testid={testId}>
            <BodyText size={size} weight="md" data-testid={testId && `${testId}-label`}>
              {detail.label}
            </BodyText>
            <BodyText size={size} className={cn('detailValue')} data-testid={testId && `${testId}-value`}>
              {detail.value}
            </BodyText>
          </div>
        );
      })}
    </div>
  );
}
